import React from 'react'
import { Navbar } from 'react-bootstrap'
import { Menu } from 'fw/components'
import Admin from '../menu/Admin'
import UserCard from '../userCard/UserCard'
import * as App from 'modules/app/App'


class Header extends React.Component {

	render() {
		const menuItems = App.context().showMenu ? App.context().menuItems : [];

		return (
			<header className="main-header">
				<a href="/" className="logo">
					<img className="pull-left logo-header-image" src="/images/logo-header.png" alt="Dashboard" />
					<span className="logo-lg" style={{ color: '#FFF' }}><b>VOCS</b></span>
				</a>

				<Navbar className="navbar navbar-static-top" fluid>
					<Navbar.Collapse className="pull-left">
						<Menu menuItems={menuItems.filter((x) => { return !x.menuRightSide })} exclude="Admin" />
					</Navbar.Collapse>

					<div className="pull-right">
						<Navbar.Toggle />
						<UserCard />
						{menuItems.filter((x) => { return x.resourceCode === "Admin" }).length > 0 &&
							<Admin menuItems={menuItems} />}
					</div>
				</Navbar>
			</header>)
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/layouts/main/header/Header.js